module.exports = __webpack_public_path__ + "static/media/arrow-down-error-yl.437456f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-error-yl.svg
// module id = 264
// module chunks = 0